import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Deprecated: upgrades are now handled by the in-app UpgradeModal and the
 * Settings billing section. This route is kept only so old /join/upgrade links
 * don't 404 — it immediately redirects to Settings.
 */
const Upgrade = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/settings', { replace: true });
  }, [navigate]);

  return null;
};

export default Upgrade;
